import { checkIsUrl } from './checkIsUrl';

export const handlePathnameSlashes = (
  pathname: string,
  trailingSlashEnabled: boolean
) => {
  const isExternalPath = checkIsUrl(pathname);

  const hasStartSlash = pathname.startsWith('/');

  const hasEndSlash = pathname.endsWith('/');

  const pathnameStart = !isExternalPath && !hasStartSlash ? '/' : '';

  if (trailingSlashEnabled) {
    const pathnameEnd = !hasEndSlash ? '/' : '';

    return `${pathnameStart}${pathname}${pathnameEnd}`;
  }

  const processedPathname = hasEndSlash ? pathname.slice(0, -1) : pathname;

  return `${pathnameStart}${processedPathname}`;
};

export default handlePathnameSlashes;
